import { useQuery } from '@tanstack/react-query';
import { gcbServerRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

export const gcbNominationsKeys = {
  detail: (identifier, identifierType) => ['gcbNominations', identifierType, identifier],
};

export const useGCNNominations = (identifier, identifierType, enabled = false) => {
  return useQuery({
    queryKey: gcbNominationsKeys.detail(identifier, identifierType),
    queryFn: async () => {
      const params = new URLSearchParams();
      if (identifierType === 'staffNumber') {
        params.append('staff_number', identifier);
      } else {
        params.append('ssnit_number', identifier);
      }
      const result = await gcbServerRequest('GET', `gcb-nominations?${params}`);
      return result.data || [];
    },
    enabled: enabled && !!identifier,
    onError: (error) => {
      notifyUser('error', error, 'Error');
    },
  });
};
